import { getValue } from 'utils/getValue';
import { hasSvgIcon } from 'utils/svgIcons';

export const FRAMEWORK_FIELD_SLUG = 'framework';

const CLAUDE_TYPE_SLUG = 'claude';

// Frameworks whose svg in assets/img/svg has a different name.
const ICON_ALIASES: { [key: string]: string } = {
  'ruby-on-rails': 'rails',
  node: 'nodejs',
  vuejs: 'vue',
  go: 'golang',
  angularjs: 'angular',
  sveltekit: 'svelte',
};

interface FrameworkIcon {
  icon: string;
  label: string;
}

export const getFrameworkIcon = (website: any): FrameworkIcon | null => {
  if (website?.type?.slug !== CLAUDE_TYPE_SLUG) return null;

  const label = getValue(website, FRAMEWORK_FIELD_SLUG);
  if (!label) return null;

  const slug = label.trim().toLowerCase();
  const icon = ICON_ALIASES[slug] || slug;
  if (!hasSvgIcon(icon)) return null;

  return { icon, label };
};
